<template>
	<div class='mzl'>

		<div class='grid select-value-block'>

			<div>
				<custom-p-checkbox
					:value='instrumRecommended'
					@input='onInstrumRecommendedChange'
					label='Рекомендуется проведение ЛПО инструментальным способом'
					:disabled='!actLpoIsDraft'
				/>
			</div>

			<div :class='{ "not-match": !isMatch(values["mzl_period_to"]) }'>
				<span class='select-title'>Рекомендуемый срок проведения мероприятий</span>
				<input type='date' class='custom-input' v-model='values["mzl_period_to"].value' :disabled='!actLpoIsDraft'>
			</div>

		</div>

		<div class='grid col-2 select-value-block'>

			<div :class='{ "not-match": notMatchingProfList }'>
				<span class='select-title'>Профилактические мероприятия</span>
				<custom-p-select
					v-model='valueProfList'
					:options='info_mzl_prof'
					multiple
					:disabled='!actLpoIsDraft'
				/>
			</div>
		</div>


		

		<div class='values-btn-row not-match-block' v-if='notMatchingValues.length ||  notMatchingProfList'>
			<div>
				<button @click='cancel'>Отмена</button>
				<button @click='save'>Сохранить</button>
			</div>
		</div>

	</div>
</template>

<script>
	import { mapState, mapActions } from 'vuex';
	import InspectionMzlSomVisual from './CurrentLpo__mzlSomVisual';

	export default {
		name: 'InspectionMzl',
		components: {
			InspectionMzlSomVisual
		},
		data() {
			return {
				valueProfList: [],

				valueInstrumRecommended: false,

				values: {

					mzl_period_to: {
						field: 'mzl_period_to',
						inputType: 'date',
						value: null
					},

				},

				catalogsAreLoading: false
			};
		},
		computed: {

			actLpoIsDraft() { return this.$store.getters['lpoData/actLpoIsDraft']; },

			instrumRecommended() {
				return !!this.valueInstrumRecommended;
			},

			notMatchingValues() {
				const result = [];

				for (const value_name in this.values) {
					if (!this.isMatch(this.values[value_name])) {
						result.push(value_name);
					}
				}

				return result;
			},

			notMatchingProfList() {

				const finded = this.profMzlList.find(mzl => mzl.mzl_id === '370');

				let profMzlListLength = this.profMzlList.length;

				if (finded) {
					profMzlListLength--;
				}

				if (this.valueProfList.length !== profMzlListLength) {
					return true;
				}

				for (const mzl of this.profMzlList) {
					if (mzl.mzl_id === '370') {
						continue;
					}

					if (!this.valueProfList.find(m => m.id === mzl.mzl_id)) {
						return true;
					}
				}

				return false;
			},

			...mapState('selectedLpo', {
				lpo: state => state['lpo'],
				profMzlList: state => state['profMzlList'],
			}),

			...mapState({
				info_mzl_prof: state => state.catalogs['info_mzl_prof'],
			})
		},
		watch: {
			profMzlList() {
				this.resetProfList();
			}
		},
		methods: {

			onInstrumRecommendedChange(checked) {
				this.toggleInstrumRecommended({ checked, mzlValue: this.valueInstrumRecommended }).then(res => {
					return this.updateProfMzlList();
				});
			},

			save() {

				if (this.notMatchingProfList) {
					this.saveProfMzlList(this.valueProfList).then(res => {
						this.updateProfMzlList();
					});
				}

				if (this.notMatchingValues.length) {

					const valueList = [];

					for (const value_name of this.notMatchingValues) {
						const inputTypeIsSelect = this.values[value_name].inputType === 'select';
						const inputTypeIsDate = this.values[value_name].inputType === 'date';
						if (inputTypeIsDate) {
							if (this.values[value_name].value == '') {
								this.values[value_name].value = null
							}
						}
						const temp = {
							field: this.values[value_name].field,
							value: inputTypeIsSelect && this.values[value_name].value ? this.values[value_name].value.id : this.values[value_name].value,
						};
						valueList.push(temp);
					}
					
					this.saveLpoValue(valueList).then(res => {
						return this.updateLpo();
					});
				}

			},
			cancel() {
				this.resetValues();
			},

			resetValues() {
				for (let value_name in this.values) {
					const value = this.values[value_name];

					if (value.inputType === 'checkbox') {
						value.value = this.lpo[value.field] === 't';
					} else if (value.inputType === 'select') {

						const temp = this[value.catalog].find(item => {
							return item.id === this.lpo[value.field];
						});
						value.value = temp ? temp : null;

					} else if (value.inputType === 'input' || value.inputType === 'date') {
						value.value = this.lpo[value.field];
					}
				}

				this.resetProfList();
			},


			resetProfList() {
				this.valueProfList = [];
				this.valueInstrumRecommended = null;

				for (const mzl of this.profMzlList) {
					if (mzl.mzl_id === '370') {
						this.valueInstrumRecommended = mzl;
						continue;
					}

					const temp = {
						id: mzl.mzl_id,
						name: mzl.name
					};

					this.valueProfList.push(temp);

				}

				// 	const temp = {
				// 		id: mzl.mzl_id,
				// 		name: mzl.name
				// 	};

				// 	this.valueProfList.push(temp);
				// }
			},

			isMatch(value) {
				if (this.catalogsAreLoading) {
					return true;
				}

				if (value.inputType === 'input' || value.inputType === 'date') {
					return value.value === this.lpo[value.field];
				} else if (value.inputType === 'select') {
					if (!value.value) {
						return this.lpo[value.field] === null;
					} else {
						return value.value.id === this.lpo[value.field];
					}
				} else if (value.inputType === 'checkbox') {
					return value.value === (this.lpo[value.field] === 't' ? true : false);
				}

				return false;
			},

			...mapActions('selectedLpo', [
				'saveProfMzlList',
				'updateProfMzlList',
				'saveLpoValue',
				'updateLpo',
				'toggleInstrumRecommended'
			])
		},
		created() {
			const catalogs = [
				'info_mzl_prof'
			];

			this.catalogsAreLoading = true;
			this.$store.dispatch('loadCatalogs', catalogs).then(res => {
				this.catalogsAreLoading = false;
				this.resetValues();
			});
		}
	};
</script>

<style scoped src='@/style/grid.css'></style>
<style scoped src='@/style/input.css'></style>
<style scoped src='@/style/button.css'></style>

<style scoped>
	.grid.col-2 {
		grid-template-columns: repeat(auto-fill, minmax(500px, 1fr));
		padding: 0;
	}

	.grid {
		align-items: center;
	}

	.flex {
		display: flex;
	}
	.flex-item {
		flex: 1;
	}


	.agit-prof-block {
		margin-top: 10px;
	}

	.not-match {
		background-color: orange;
	}

	.select-value-block {
		margin-top: 34px;
	}

	.select-title {
		font-weight: bold;
		display: inline-block;
		margin-bottom: 6px;
	}
</style>